import { useStores } from '@a2d24/care-at-work-state/stores';


const ReportDashboardFrame = ({props}) => {
    const { authStore } = useStores();
    const frameUrls = authStore.getFrameUrlsForRole()
    return(
        <div style={{
            'display': 'flex',
            'width': '100%',
            'height': '800px',
            'padding': '25px'
        }}>
            {(frameUrls && frameUrls.length >0)?
                <iframe
                    src={frameUrls[0].frame_url}
                    frameBorder={0}
                    width={'90%'}
                    height={'auto'}
                />
                :
                null
            }
        </div>

    )
}
export default ReportDashboardFrame;
